import { SimplifyGatsbyQuery, CountdownBlock as CountdownBlockCore, ExistingThemes } from "@parksandresorts/core";
import { graphql } from "gatsby";

const CountdownBlock = ({
  contentful_id,
  headline,
  firstText,
  secondText,
  callToActionButton,
  size,
  image,
  targetDateTime,
  useCustomColors,
  customColors,
  finishedEffect,
  finishedText,
  componentTheme,
  backgroundColor,
}: SimplifyGatsbyQuery<Queries.CountdownBlockFragment>) => {
  const checkedFinishedEffect = finishedEffect === "showText" && finishedText ? finishedEffect : "disappear";
  return (
    <CountdownBlockCore
      contentfulId={contentful_id}
      componentTheme={componentTheme as ExistingThemes}
      heading={headline}
      primaryText={firstText}
      secondaryText={secondText}
      targetDateTimeStockholm={targetDateTime}
      callToActionButton={callToActionButton}
      size={size as "xs" | "s" | "m" | "l"}
      hasBackgroundColor={backgroundColor}
      colorOverrides={useCustomColors ? customColors : undefined}
      countdownFinishedEffect={checkedFinishedEffect}
      finishedText={finishedText}
      image={
        image
          ? {
              xs: {
                description: image.description,
                gatsbyImageData: image.gatsbyImageDataXs,
              },
              s: {
                description: image.description,
                gatsbyImageData: image.gatsbyImageDataS,
              },
              m: {
                description: image.description,
                gatsbyImageData: image.gatsbyImageDataM,
              },
              l: {
                description: image.description,
                gatsbyImageData: image.gatsbyImageDataL,
              },
            }
          : undefined
      }
    />
  );
};

export default CountdownBlock;

export const fragmentCountdownBlock = graphql`
  fragment CountdownBlock on ContentfulCountdownBlock {
    contentful_id
    componentTheme
    headline
    firstText {
      raw
    }
    secondText {
      raw
    }
    callToActionButton {
      title
      externalUrl
      internalLink {
        slug
        title
      }
      openInNewTab
    }
    size
    image {
      description
      gatsbyImageDataXs: gatsbyImageData(width: 512)
      gatsbyImageDataS: gatsbyImageData(width: 640)
      gatsbyImageDataM: gatsbyImageData(width: 960)
      gatsbyImageDataL: gatsbyImageData(width: 1440)
    }
    targetDateTime
    useCustomColors
    customColors {
      backgroundColor
      textColor
      dayBackgroundColor
      dayTextColor
      dayLineColor
      hourBackgroundColor
      hourTextColor
      hourLineColor
      minuteBackgroundColor
      minuteTextColor
      minuteLineColor
      secondBackgroundColor
      secondTextColor
      secondLineColor
      buttonBackgroundColor
      buttonTextColor
    }
    finishedEffect
    finishedText {
      raw
    }
    backgroundColor
  }
`;
